module.exports = __webpack_public_path__ + "img/mubokuCScrn1.936c72fb.png";